class CartDiscountCode extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[name="discount"]');
    this.submitButton = this.querySelector('.cart-discount-code__submit');
    this.removeButton = this.querySelector('.cart-discount-code__remove');
    this.messageEl = this.querySelector('.cart-discount-code__message');

    this.submitButton.addEventListener('click', this.onSubmit.bind(this));
    if (this.removeButton) {
      this.removeButton.addEventListener('click', this.onRemove.bind(this));
    }
    this.input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        this.onSubmit();
      }
    });
  }

  setMessage(text, type) {
    this.messageEl.textContent = text;
    this.messageEl.classList.remove('cart-discount-code__message--success', 'cart-discount-code__message--error');
    if (type) this.messageEl.classList.add(`cart-discount-code__message--${type}`);
  }

  updateSections(cart) {
    if (cart.sections && cart.sections['main-cart-footer']) {
      const parser = new DOMParser();
      const newDoc = parser.parseFromString(cart.sections['main-cart-footer'], 'text/html');
      const newContents = newDoc.querySelector('.js-contents');
      const oldContents = document.querySelector('#main-cart-footer .js-contents');
      if (newContents && oldContents) {
        oldContents.replaceWith(newContents);
      }
    }
  }

  onSubmit() {
    const code = this.input.value.trim();
    if (!code || this.submitButton.disabled) return;

    this.submitButton.disabled = true;
    this.setMessage('Aplicando código...', null);

    fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        discount: code,
        sections: ['main-cart-footer'],
        sections_url: window.location.pathname,
      }),
    })
      .then((response) => response.json())
      .then((cart) => {
        const applications = cart.cart_level_discount_applications || [];
        const applied = applications.some((discount) => discount.title.toLowerCase() === code.toLowerCase());

        this.updateSections(cart);
        if (this.removeButton) this.removeButton.hidden = applications.length === 0;

        if (applied) {
          this.setMessage('Código aplicado correctamente.', 'success');
          this.input.value = '';
        } else {
          this.setMessage('Ese código no es válido o ha caducado.', 'error');
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-discount-code', cartData: cart });
        }
      })
      .catch(() => {
        this.setMessage('No se pudo aplicar el código. Inténtalo de nuevo.', 'error');
      })
      .finally(() => {
        this.submitButton.disabled = false;
      });
  }

  onRemove() {
    if (!this.removeButton || this.removeButton.disabled) return;

    this.removeButton.disabled = true;
    this.setMessage('Desactivando código...', null);

    fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        discount: '',
        sections: ['main-cart-footer'],
        sections_url: window.location.pathname,
      }),
    })
      .then((response) => response.json())
      .then((cart) => {
        this.updateSections(cart);
        this.removeButton.hidden = true;
        this.setMessage('Código desactivado.', 'success');

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-discount-code', cartData: cart });
        }
      })
      .catch(() => {
        this.setMessage('No se pudo desactivar el código. Inténtalo de nuevo.', 'error');
      })
      .finally(() => {
        this.removeButton.disabled = false;
      });
  }
}

customElements.define('cart-discount-code', CartDiscountCode);
